<template>
<Head>
    <title>Wakaf Pahang - Pembayaran wakaf dalam talian</title>
    <meta name="description" content="Mari kita berwakaf di Wakaf Pahang. Semai di dunia, tuai di akhirat. Semoga Allah terima amalan kita." />
    <meta name="keywords" content="Wakaf Pahang, Pahang, Wakaf, Islam, Islam Indah, Muslim, Pahala, Infaq Ramadan, Ramadan" />
    <meta property="og:url" :content="uri" />
    <meta property="og:title" content="Wakaf Pahang - Pembayaran wakaf dalam talian" />
    <meta property="og:description" content="Mari kita berwakaf di Wakaf Pahang. Semai di dunia, tuai di akhirat. Semoga Allah terima amalan kita." />
    <meta property="og:type" content="website" />
    <meta property="og:image" :content="uri + '/img/og/payment2.png'" />
    <meta property="og:image:secure_url" :content="uri +'/img/og/payment2.png'" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="627" />
    <meta property="og:site_name" content="Pembayaran wakaf dalam talian" />
    <meta property="og:locale" content="ms_MY" />
    <meta property="twitter:url" :content="uri" />
    <meta property="twitter:title" content="Wakaf Pahang - Pembayaran wakaf dalam talian" />
    <meta property="twitter:description" content="Mari kita berwakaf di Wakaf Pahang. Semai di dunia, tuai di akhirat. Semoga Allah terima amalan kita." />
    <meta property="twitter:card" content="summary_large_image" />
    <meta property="twitter:image" :content="uri +'/img/og/payment2.png'" />
    <meta property="twitter:image:width" content="1200" />
    <meta property="twitter:image:height" content="627" />
    <meta property="twitter:domain" content="Wakaf Pahang" />
    <meta property="twitter:locale" content="ms_MY" />
    <link rel="preload" fetchpriority="high" as="image" :href="img_wakafpahang" type="image/webp">
    <link rel="preload" fetchpriority="high" as="image" :href="ezid_logo" type="image/webp">
    <link rel="shortcut apple-touch-icon icon" as="image" :href="img_favicon" type="image/png">
</Head>

<div class="min-vh-100 py-3 py-md-4 d-flex align-items-center justify-content-center">
    <form method="post" class="w-100" @submit.prevent="submitForm">
        <section class="container px-3 px-md-4">
            <div class="row justify-content-center mb-3">
                <div class="col-lg-12">
                    <div class="alert alert-warning border-warning border-opacity-50 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between p-2 p-md-3 rounded-3 rounded-md-4 shadow-sm mb-0" style="background-color: #fffbeb;">
                        <div class="d-flex align-items-center gap-2 mb-2 mb-md-0 text-dark">
                            <span class="fw-medium" style="font-size: 0.8rem;">Pernah berwakaf sebelum ini? Log masuk untuk proses yang lebih pantas.</span>
                        </div>
                        <div class="d-flex flex-wrap gap-2">
                            <a :href="ezid_url" target="_blank" class="btn btn-light btn-sm border fw-medium d-flex align-items-center gap-2 shadow-sm rounded-3">
                                <img :src="ezid_logo" height="16" width="16" alt="Logo Ezid" decoding="async">
                                Log Masuk e-Zid
                            </a>
                            <button class="btn btn-outline-danger btn-sm rounded-3" :class="[showCloseBtn ? 'd-inline-flex' : 'd-none']"
                                    @click="cancelFormSubmit" type="button">
                                <font-awesome-icon :icon="faXmark" class="me-1" /> Batal
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-3 justify-content-center">
                <div class="col-12 col-lg-7 order-1 order-lg-1">
                    <div class="card border-0 shadow-sm rounded-3 rounded-md-4 p-3 p-md-4 bg-white">
                        <div class="d-flex flex-column flex-sm-row justify-content-center justify-content-sm-between align-items-center align-items-sm-center border-bottom pb-3 mb-3">
                            <div class="mb-2 mb-sm-0 text-center text-sm-start">
                                <img :src="img_wakafpahang" decoding="async" alt="Wakaf Pahang" class="img-fluid" style="height: 45px; width: 220px;">
                            </div>
                            <div class="text-center text-sm-end">
                                <h1 class="fs-6 fw-bold mb-0 text-dark">Sistem Pembayaran Wakaf Pahang</h1>
                                <p class="text-muted mb-0" style="font-size: 0.75rem;">info@wakafpahang.my | 09-514-5151</p>
                            </div>
                        </div>
                        <h2 class="fs-6 fw-bold mb-3 d-flex align-items-center gap-2">Maklumat Pewakaf</h2>
                        <div class="row g-2">
                            <div class="col-12">
                                <label class="form-label fw-medium small text-dark mb-1" for="namPembayar">Nama</label>
                                <input v-model="wakaf.Nama" id="namPembayar" type="text" class="form-control rounded-3 py-2" ref="nameRef"
                                       :class="{'is-invalid': wakaf.error.Nama.flag}"
                                       @input="updateWakafDataSendiriOption(($event.target as HTMLInputElement).value)"
                                       placeholder="Nama penuh anda seperti dalam kad pengenalan">
                                <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.Nama.flag }">
                                    {{ wakaf.error.Nama.message }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-medium small text-dark mb-1" for="noKPPembayar">No. Kad Pengenalan Diri</label>
                                <input v-model="wakaf.NoKP" id="noKPPembayar" type="text" class="form-control rounded-3 py-2"
                                       :class="{'is-invalid': wakaf.error.NoKP.flag}"
                                       placeholder="No. Mykad/Passport/Anggota" @focusout="formatIC">
                                <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.NoKP.flag }">
                                    {{ wakaf.error.NoKP.message }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-medium small text-dark mb-1" for="NoTelPembayar">No. Telefon Bimbit</label>
                                <input v-model="wakaf.TelefonBimbit" id="NoTelPembayar" type="text" class="form-control rounded-3 py-2"
                                       :class="{'is-invalid': wakaf.error.TelefonBimbit.flag}"
                                       placeholder="No. telefon bimbit yang aktif">
                                <div class="form-text">Contoh: 0129012345</div>
                                <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.TelefonBimbit.flag }">
                                    {{ wakaf.error.TelefonBimbit.message }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-medium small text-dark mb-1" for="emelPembayar">E-mel</label>
                                <input v-model="wakaf.EMel" id="emelPembayar" type="email" class="form-control rounded-3 py-2"
                                       :class="{'is-invalid': wakaf.error.EMel.flag}"
                                       placeholder="Alamat e-mel yang aktif">
                                <div class="form-text">Contoh: ahmad@wakafpahang.my</div>
                                <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.EMel.flag }">
                                    {{ wakaf.error.EMel.message }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-medium small text-dark mb-1" for="daerahPembayar">Daerah Pewakaf</label>
                                <select class="form-select rounded-3 py-2" id="daerahPembayar" v-model="wakaf.daerahPembayar"
                                        :class="{'is-invalid': wakaf.error.daerahPembayar.flag}">
                                    <option value="0" selected disabled>Sila Pilih Daerah Tempat Tinggal</option>
                                    <template v-for="daerah in district">
                                        <option v-if="daerah.KodDaerah !== 12" :value="daerah.KodDaerah" class="text-capitalize">
                                            {{ daerah.Daerah }}
                                        </option>
                                    </template>
                                </select>
                                <div class="invalid-feedback" :class="{ 'd-block': wakaf.error.daerahPembayar.flag }">
                                    {{ wakaf.error.daerahPembayar.message }}
                                </div>
                            </div>
                        </div>
                        <div class="mt-3 pt-3 border-top text-center">
                            <p class="fw-bold text-secondary mb-1" style="font-size: 0.8rem;">Hakcipta Terpelihara © {{ currentYear }} Pusat Kutipan Zakat dan Wakaf Pahang</p>
                            <p class="text-muted mb-0" style="font-size: 0.75rem;">Pembayaran selamat melalui FPX (Perbankan Internet). Semai di dunia, tuai di akhirat.</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-5 order-2 order-lg-2">
                    <div class="card border-0 shadow-sm rounded-3 rounded-md-4 p-3 sticky-lg-top bg-white" style="top: 16px;">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h2 class="fs-6 fw-bold mb-0 d-flex align-items-center gap-2">Senarai Wakaf</h2>
                            <button class="btn btn-primary btn-sm rounded-3 fw-medium d-flex align-items-center gap-1 shadow-sm" type="button" @click="wakafDataRef?.openAddModal()">
                                <span class="fw-bold">+</span> Tambah
                            </button>
                        </div>
                        <transaction-public ref="wakafDataRef" :wakaf_type='wakaf_type' :wakaf_district='wakaf_district'
                                            :wakaf_project='wakaf_project' :nama_pewakaf="wakaf.Nama" :w_id="data.wid"
                                            :d_id="data.did" :p_id="data.pid" @update-name="updateNameParent"
                                            @calulate-sum="calculateSum"></transaction-public>
                        <div class="bg-light border rounded-3 p-2 mt-3">
                            <p class="mb-1 text-muted" style="font-size: 0.75rem;">Boleh tambah sehingga 10 maklumat wakaf.</p>
                            <p class="mb-0 text-muted" style="font-size: 0.75rem;">Caj transaksi FPX sebanyak RM 0.50 akan dikenakan.</p>
                        </div>
                        <div v-if="isDisplayGrandSumAndSubmit" class="d-flex justify-content-between align-items-center mt-3 mb-3 p-3 rounded-3 bg-amount">
                            <span class="fw-medium small text-dark">Jumlah Keseluruhan</span>
                            <span class="fs-4 fw-bold text-amount">{{ sumFormat(sum) }}</span>
                        </div>
                        <div v-else class="mt-3 mb-3 pb-2 border-bottom text-muted" style="font-size: 0.85rem;">
                            Tambah maklumat wakaf untuk melihat jumlah bayaran.
                        </div>
                        <button v-if="isDisplayGrandSumAndSubmit" class="btn bg-brand w-100 py-2 rounded-3 fw-bold shadow-sm d-flex justify-content-center align-items-center gap-2" type="submit">
                            Teruskan Pembayaran
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </form>
</div>
<!--<footerFPX class="mt-5" :year="currentYear"></footerFPX>-->
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import { Head } from '@inertiajs/vue3';
import axios from "axios";
import Swal from "sweetalert2";
import { sumFormat } from "@/utils/utils";
import { type Pewakaf} from "../interface/Pewakaf";
import transactionPublic from "./transactionPublic.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faPaperPlane, faXmark, faPhone } from "@fortawesome/free-solid-svg-icons";
import type {FormGeneral} from "../interface/FormGeneral";
library.add(faPaperPlane, faXmark, faPhone);


const sum: Ref = ref<number>(0);
const nameRef: Ref = ref<HTMLInputElement>();
const showCloseBtn: Ref = ref<boolean>(false);
const wakafDataRef: Ref = ref<InstanceType<typeof transactionPublic> | null>(null);
const isDisplayGrandSumAndSubmit: Ref = ref<boolean>(false);

const data = defineProps<{
    img_wakafpahang: string,
    img_wakafconfrim: string,
    ezid_url: string,
    img_favicon: string,
    csrf: string,
    submit_url: string,
    ezid_logo: string,
    district: [{
        KodDaerah: number,
        Daerah: string,
    }],
    wakaf_type: [{
        id: number,
        Nama: string,
    }],
    wakaf_district: [{
        KodDaerah: number,
        WakafJenisID: number,
        daerah: string,
    }],
    wakaf_project: [{
        kod: number,
        nama: string,
        WakafJenisID: number,
        DaerahID: number,
    }],
    currentYear: number,
    uri: string,
    wid?: number,
    did?: number,
    pid?: number | string,
}>();

const wakaf = ref<Pewakaf>({
    Nama: "",
    TelefonBimbit: "",
    daerahPembayar: 0,
    NoKP: "",
    EMel: "",
    error:{
        Nama: {
            flag: false,
            message:""
        },
        TelefonBimbit: {
            flag: false,
            message:""
        },
        NoKP: {
            flag: false,
            message:""
        },
        EMel: {
            flag: false,
            message:""
        },
        daerahPembayar: {
            flag: false,
            message:""
        }
    }
});

// const wakafDataRef = ref(null)
// const version = computed(() => wakafDataRef.value?.version)

onMounted(() => {
    nameRef.value.focus()
    if (window.opener !== null) {
        showCloseBtn.value = true;
    }
});

const updateNameParent = (name: string, type: string): void => {
    if (type === "Sendiri") {
        wakaf.value.Nama = name;
    }
}
const updateWakafDataSendiriOption = (name: string): void => {
    wakafDataRef.value.transactionPublic.forEach(function (item: FormGeneral, index: number) {
        if (wakafDataRef.value.transactionPublic[index].jenisPemilik === "Sendiri") {
            wakafDataRef.value.transactionPublic[index].namaPemilik = name;
        }
    })
}

const formatIC = (): void => {
    if (wakaf.value.NoKP.length === 12) {
        wakaf.value.NoKP = wakaf.value.NoKP.slice(0, 6) + "-" + wakaf.value.NoKP.slice(6, 8) + "-" + wakaf.value.NoKP.slice(8, 14);
    }
}
const calculateSum = (summ: number) : void =>{
    if(wakafDataRef.value.transactionPublic.length === 0) {
        isDisplayGrandSumAndSubmit.value = false;
        sum.value = 0;
    } else if (wakafDataRef.value.transactionPublic.length > 0) {
        isDisplayGrandSumAndSubmit.value = true;
        sum.value = summ;
    }
}

const submitForm = (): void => {
    let formValidation: boolean = true;
    wakaf.value.Nama = wakaf.value.Nama.trim();
    wakaf.value.TelefonBimbit = wakaf.value.TelefonBimbit.trim();
    wakaf.value.NoKP = wakaf.value.NoKP.trim();
    wakaf.value.EMel = wakaf.value.EMel.trim();
    wakaf.value.error.Nama.flag = false;
    wakaf.value.error.TelefonBimbit.flag = false;
    wakaf.value.error.NoKP.flag = false;
    wakaf.value.error.EMel.flag = false;
    wakaf.value.error.daerahPembayar.flag = false;
    if(wakaf.value.Nama.length <= 5 || wakaf.value.Nama.length > 150){
        formValidation = false;
        wakaf.value.error.Nama.flag = true;
        wakaf.value.error.Nama.message = "Sila masukkan nama yang sah";
    }
    // check only for mobile number
    if(!new RegExp("^(01)[02-46-9][0-9]{7}$|^(01)1[0-9]{8}$", "g").test(wakaf.value.TelefonBimbit)){
        formValidation = false;
        wakaf.value.error.TelefonBimbit.flag = true;
        wakaf.value.error.TelefonBimbit.message = "Sila masukkan nombor telefon bimbit yang sah";
    }
    if(wakaf.value.NoKP.length <= 5){
        formValidation = false;
        wakaf.value.error.NoKP.flag = true;
        wakaf.value.error.NoKP.message = "Sila masukkan nombor pengenalan diri yang sah";
    }
    if(wakaf.value.EMel.length <= 5 || wakaf.value.EMel.length > 150){
        formValidation = false;
        wakaf.value.error.EMel.flag = true;
        wakaf.value.error.EMel.message = "Sila masukkan emel yang sah";
    }
    if(wakaf.value.daerahPembayar === 0){
        formValidation = false;
        wakaf.value.error.daerahPembayar.flag = true;
        wakaf.value.error.daerahPembayar.message = "Sila pilih daerah anda";
    }
    if(formValidation){
        Swal.fire({
            title: "Anda pasti untuk hantar ?",
            html: `<p class="fs-6">Saya dengan ini mewakafkan nilai sebanyak <b> ${sumFormat(sum.value)}</b> selama-lamanya kerana Allah Ta'ala</p>
                    <p style="font-size: 12px" class="fst-italic">Tiada caj pengurusan akan diambil terhadap amaun wakaf. Pihak pengurusan hanya diizinkan mengambil caj pengurusan daripada hibah / keuntungan deposit wang wakaf (jika ada) pada kadar tidak melebihi separuh amaun hibah / keuntungan deposit.</p>
                   `,
            imageUrl: data.img_wakafconfrim,
            imageWidth: 128,
            imageHeight: 128,
            showConfirmButton: true,
            confirmButtonColor: "#198754",
            confirmButtonText: "Ya, saya wakafkan",
            showCancelButton: true,
            cancelButtonText: "Kembali",
            cancelButtonColor: "#0d6efd",
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
            backdrop: true,
            reverseButtons: true,
            preConfirm: async() => {
                // return 0
                let jenisWakaff : number[] = [];
                let daerahWakaff : number[] = [];
                let projekWakaff : number[] = [];
                let unitt : number[] = [];
                let jumlahh : number[] = [];
                let jenisPemilikk : string[] = [];
                let namaPemilikk : string[] = [];
                wakafDataRef.value?.transactionPublic.forEach((item: FormGeneral) => {
                    jenisWakaff.push(item.jenisWakaf);
                    daerahWakaff.push(item.daerahWakaf);
                    projekWakaff.push(item.projekWakaf);
                    unitt.push(item.unit);
                    jumlahh.push(item.jumlah);
                    jenisPemilikk.push(item.jenisPemilik);
                    namaPemilikk.push(item.namaPemilik);
                })
                return axios({
                    method: "post",
                    url: data.submit_url,
                    data: {
                        csrf: data.csrf,
                        Nama: wakaf.value.Nama,
                        TelefonBimbit: wakaf.value.TelefonBimbit,
                        daerahPembayar: wakaf.value.daerahPembayar,
                        NoKP: wakaf.value.NoKP,
                        EMel: wakaf.value.EMel,
                        jenisWakaf: jenisWakaff,
                        daerahWakaf: daerahWakaff,
                        projekWakaf: projekWakaff,
                        unit: unitt,
                        jumlah: jumlahh,
                        jenisPemilik: jenisPemilikk,
                        namaPemilik: namaPemilikk,
                    }
                }).then(function (response) {
                    window.location.href = response.data;
                }).catch(function (error) {
                    Swal.fire({
                        icon: "error",
                        title: "Ralat berlaku",
                        text: "Sila cuba semula untuk hantar. " + error.body.message,
                        timer: 5000,
                        timerProgressBar: true,
                        confirmButtonColor: "#0d6efd",
                        confirmButtonText: "Ok",
                    })
                });
            },
        })
    }
}

const cancelFormSubmit = () => {
    Swal.fire({
        position: "top",
        icon: "question",
        title: "Anda pasti untuk batal?",
        showConfirmButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Ya",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd"
    }).then((result) => {
        if (result.isConfirmed) {
            window.close()
        }
    })
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

:global(body) {
    font-family: 'Inter', sans-serif;
    background-color: #f1f5f9;
}

.text-brand {
    color: #4b2045 !important;
}

.bg-brand {
    background-color: #4b2045 !important;
    color: white !important;
}

.bg-brand:hover {
    background-color: #3a1835 !important;
    color: white !important;
}

.bg-amount {
    background-color: #fef3e2;
    border: 1px solid #f59e0b;
}

.text-amount {
    color: #d97706;
}

.form-control:focus,
.form-select:focus {
    border-color: #4b2045;
    box-shadow: 0 0 0 0.25rem rgba(75, 32, 69, 0.15);
    background-color: #ffffff;
}

.form-control,
.form-select {
    background-color: #ffffff;
}

.form-control:disabled,
.form-control[readonly] {
    background-color: #fafafa;
}

/* Responsive adjustments */
@media (max-width: 575.98px) {
    .card {
        border-radius: 12px !important;
    }

    .form-control,
    .form-select {
        font-size: 16px; /* Prevents zoom on iOS */
        padding: 0.5rem 0.75rem;
    }

    .btn {
        font-size: 0.85rem;
    }
}

@media (min-width: 576px) and (max-width: 991.98px) {
    .card {
        border-radius: 16px !important;
    }
}

@media (min-width: 992px) {
    .sticky-lg-top {
        position: sticky;
        top: 16px;
    }
}
</style>
